<template>
  <div class="page">
    <div class="home">
      <a href="https://maac.io/212za" target="_blank">
        <img src="./images/home.jpg" class="img-fluid" />
      </a>


    </div>
  </div>
</template>
<script>
export default {

}
</script>

<style lang="scss" scoped></style>
